import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לזרות",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להשתנות.",
      "אני רק שם/ה לב לזרות כמו שהיא.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה להשתנות.",
      "אני רק שם/ה לב לזרות כמו שהיא.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הזרות הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי הזרות הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לזרות הוא כבר קשר עדין."
    ],
      [
      "לשים לב לזרות הוא כבר קשר עדין."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה חסר לי כאן",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שחסר לי כאן.",
      "בלי השוואה.",
      "רק להרגיש."
    ],
      [
      "היום אני שם/ה לב למה שחסר לי כאן.",
      "בלי השוואה.",
      "רק להרגיש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חסר לי מהבית הישן?",
      "מה הייתי רוצה שיהיה לי כאן?",
      "מה קשה לי לבקש?"
    ],
      [
      "מה חסר לי מהבית הישן?",
      "מה הייתי רוצה שיהיה לי כאן?",
      "מה קשה לי לבקש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חסר קטן מסביר הרבה."
    ],
      [
      "חסר קטן מסביר הרבה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על החסר.",
      "לכתוב מילה אחת על החסר."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה אני כן מביא/ה",
    opening: localizedGenderNode(
      [
      "היום אני זוכר/ת מה אני כן מביא/ה איתי.",
      "לא לאבד.",
      "רק לזכור."
    ],
      [
      "היום אני זוכר/ת מה אני כן מביא/ה איתי.",
      "לא לאבד.",
      "רק לזכור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה דבר אחד מהבית נשאר בי?",
      "מה בי לא השתנה?",
      "איך זה מרגיש לזכור את זה?"
    ],
      [
      "איזה דבר אחד מהבית נשאר בי?",
      "מה בי לא השתנה?",
      "איך זה מרגיש לזכור את זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להביא איתי משהו מהבית הוא עוגן."
    ],
      [
      "להביא איתי משהו מהבית הוא עוגן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב דבר אחד שאני מביא/ה איתי.",
      "לכתוב דבר אחד שאני מביא/ה איתי."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "רגעים של שייכות קטנה",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגעים קטנים של שייכות.",
      "גם אם קצרים.",
      "הם קיימים."
    ],
      [
      "היום אני מחפש/ת רגעים קטנים של שייכות.",
      "גם אם קצרים.",
      "הם קיימים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הרגשתי טיפת שייכות כאן?",
      "מה אפשר לי להרגיש אותה?",
      "איך זה מרגיש בגוף?"
    ],
      [
      "מתי הרגשתי טיפת שייכות כאן?",
      "מה אפשר לי להרגיש אותה?",
      "איך זה מרגיש בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם טיפה של שייכות משנה משהו."
    ],
      [
      "גם טיפה של שייכות משנה משהו."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד לטעות כאן",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת את הפחד לטעות.",
      "לא להילחם.",
      "רק לראות."
    ],
      [
      "היום אני בודק/ת את הפחד לטעות.",
      "לא להילחם.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת כאן?",
      "מה אני חושב/ת שיקרה אם אטעה?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "ממה אני מפחד/ת כאן?",
      "מה אני חושב/ת שיקרה אם אטעה?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד כאן הוא גם רצון להשתייך."
    ],
      [
      "פחד כאן הוא גם רצון להשתייך."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "צעד קטן של נראות",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של נראות.",
      "לא גדול.",
      "קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של נראות.",
      "לא גדול.",
      "קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני יכול/ה לעשות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני יכול/ה לעשות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי להתחיל."
    ],
      [
      "צעד קטן מספיק כדי להתחיל."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להישאר עוד רגע",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עוד רגע במקום חדש.",
      "לא לברוח מהר.",
      "רק רגע."
    ],
      [
      "היום אני מתרגל/ת להישאר עוד רגע במקום חדש.",
      "לא לברוח מהר.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני נסוג/ת מהר מדי?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ],
      [
      "מתי אני נסוג/ת מהר מדי?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוד רגע אחד יכול לפתוח דלת."
    ],
      [
      "עוד רגע אחד יכול לפתוח דלת."
    ]
    ),
    action: localizedGenderNode(
      "לעצור 10 שניות לפני שאני נסוג/ת.",
      "לעצור 10 שניות לפני שאני נסוג/ת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מקום קטן להיכרות",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מקום קטן להיכרות.",
      "לא הרבה.",
      "קצת."
    ],
      [
      "היום אני בודק/ת מקום קטן להיכרות.",
      "לא הרבה.",
      "קצת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אפשר להרגיש קצת קרוב?",
      "מה נותן לי ביטחון שם?",
      "מה צעד קטן שאפשר לעשות?"
    ],
      [
      "איפה אפשר להרגיש קצת קרוב?",
      "מה נותן לי ביטחון שם?",
      "מה צעד קטן שאפשר לעשות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קירבה קטנה יכולה להתחיל כאן."
    ],
      [
      "קירבה קטנה יכולה להתחיל כאן."
    ]
    ),
    action: localizedGenderNode(
      "לזהות מקום קטן שמרגיש בטוח.",
      "לזהות מקום קטן שמרגיש בטוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "מילה אחת בשפה שלי",
    opening: localizedGenderNode(
      [
      "היום אני מביא/ה מילה אחת בשפה שלי.",
      "כמו עוגן.",
      "מילה אחת."
    ],
      [
      "היום אני מביא/ה מילה אחת בשפה שלי.",
      "כמו עוגן.",
      "מילה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מילה מחזירה אותי הביתה?",
      "מתי לומר אותה עושה לי טוב?",
      "איך זה מרגיש בגוף?"
    ],
      [
      "איזו מילה מחזירה אותי הביתה?",
      "מתי לומר אותה עושה לי טוב?",
      "איך זה מרגיש בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה אחת יכולה להיות בית קטן."
    ],
      [
      "מילה אחת יכולה להיות בית קטן."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המילה בלב פעם אחת.",
      "לומר את המילה בלב פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה קטנה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה לעצמי.",
      "לא דרמה.",
      "בקשה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה לעצמי.",
      "לא דרמה.",
      "בקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי רוצה שיקרה כאן?",
      "איך אפשר לבקש זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה הייתי רוצה שיקרה כאן?",
      "איך אפשר לבקש זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לפתוח דלת."
    ],
      [
      "בקשה אחת יכולה לפתוח דלת."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "דבר קטן שמחזיק",
    opening: localizedGenderNode(
      [
      "היום אני מזהה דבר קטן שמחזיק אותי כאן.",
      "גם אם קטן.",
      "זה מספיק."
    ],
      [
      "היום אני מזהה דבר קטן שמחזיק אותי כאן.",
      "גם אם קטן.",
      "זה מספיק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מחזיק אותי בימים קשים כאן?",
      "מי או מה נותן לי טיפת יציבות?",
      "איך זה מרגיש כשיש לי משהו כזה?"
    ],
      [
      "מה מחזיק אותי בימים קשים כאן?",
      "מי או מה נותן לי טיפת יציבות?",
      "איך זה מרגיש כשיש לי משהו כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "משהו קטן יכול להיות עוגן."
    ],
      [
      "משהו קטן יכול להיות עוגן."
    ]
    ),
    action: localizedGenderNode(
      "להחזיק משהו שמרגיע אותי לרגע.",
      "להחזיק משהו שמרגיע אותי לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להיות איתי כאן",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להיות איתי גם כאן.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להיות איתי גם כאן.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מחזיר אותי לעצמי כאן?",
      "מה מוציא אותי מעצמי כאן?",
      "מה יכול לעזור לי להישאר?"
    ],
      [
      "מה מחזיר אותי לעצמי כאן?",
      "מה מוציא אותי מעצמי כאן?",
      "מה יכול לעזור לי להישאר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתי כאן הוא כבר שייכות."
    ],
      [
      "להיות איתי כאן הוא כבר שייכות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת בכל מקום זר.",
      "נשימה אחת בכל מקום זר."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של שייכות",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של שייכות.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של שייכות.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי להתקרב."
    ],
      [
      "צעד קטן מספיק כדי להתקרב."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לשייכות.",
      "כשאני מרגיש/ה זר/ה.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לשייכות.",
      "כשאני מרגיש/ה זר/ה.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הזרות הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הזרות הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש זר/ה ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש זר/ה ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const feelingForeignInANewCountryCultureBlueprintHe = buildNormalizedPilotBlueprint({
  id: "feeling_foreign_in_a_new_country_culture_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "feeling_foreign_in_a_new_country_culture",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת זרות במדינה / תרבות חדשה",
    en: "Feeling foreign in a new country / culture",
    es: "Sensación de extrañeza en un país / cultura nueva",
  },
  days,
});

export default feelingForeignInANewCountryCultureBlueprintHe;
